import request from "../../../utils/wapRequest";

const url = process.env.VUE_APP_WAP_API;

const StyleConfig = {
  getStyleConfig(data) {
    return request({
      url: `${url}/get-style-config`,
      method: "POST",
      data
    });
  }
};
export { StyleConfig as default };
